import React, { Component } from "react";
import PropTypes from "prop-types";
import GridPagination from "./grid-pagination";

export class GridNav extends Component {
  static propTypes = {
    closeProductDrawer: PropTypes.func,
    nextPage: PropTypes.bool,
    onChangePage: PropTypes.func,
    page: PropTypes.number,
    path: PropTypes.string,
    previousPage: PropTypes.bool,
    resultsCount: PropTypes.number,
    totalPages: PropTypes.number,
  };

  renderPagination() {
    const { resultsCount } = this.props;
    if (!resultsCount) {
      return;
    }

    return (
      <GridPagination
        key="grid-nav-pagination-container"
        path={this.props.path}
        page={this.props.page}
        totalPages={this.props.totalPages}
        nextPage={this.props.nextPage}
        previousPage={this.props.previousPage}
        resultsCount={this.props.resultsCount}
        closeProductDrawer={this.props.closeProductDrawer}
        onChangePage={this.props.onChangePage}
        placement="top"
      />
    );
  }

  render() {
    return <nav className={"grid-nav"}>{this.renderPagination()}</nav>;
  }
}

export default GridNav;
